/*

  Implementated by Amit Sharma
  Dated : 11/26/2019

*/

import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Modal } from 'reactstrap';
import EmployerRegistrationForm from "./EmployerRegistrationForm";
import EmployerDetailsForm from "./EmployerDetailsForm";
import EmployerJobDetails from "./EmployerJobDetails";
import EmployerEnterpriseCustomSuccess from "./EmployerEnterpriseCustomSuccess";
import { validateIP, validateInternational } from "corp-site/services/fusionValidators";

class EmployerRegistration extends Component {

   constructor(props) {
      super(props);
      this.state = {
         page: 1,
         currentCompany: 'Hiring Company',
         isIPAddressBlacklisted: false,
         isValidInternational: true.valueOf,
         email: "",
         password: ""
      };
      this.onEmployerRegistrationFormSuccess = this.onEmployerRegistrationFormSuccess.bind(this);
   }

   componentDidMount() {
      this.subscription = validateIP().subscribe(res => {
         const { isIPAddressBlacklisted } = res;
         this.setState({ isIPAddressBlacklisted });
      });

      const validateInternationSubscription = validateInternational().subscribe(res => {
         const { isValidInternational } = res;
         this.setState({ isValidInternational });
      });

      if (this.subscription) {
         this.subscription.add(validateInternationSubscription);
      } else {
         this.subscription = validateInternationSubscription;
      }
   }

   componentWillUnmount() {
      if (this.subscription) {
         this.subscription.unsubscribe();
      }
   }

   onEmployerRegistrationFormSuccess = () => {
      this.setState({
         page: this.state.page + 1,
      });
   };

   setCompany = (currentCompany) => {
      this.setState({
         currentCompany
      });
   };

   setEmail = (email) => {
      this.setState({
         email
      });
   }

   setPW = (password) => {
      this.setState({
         password
      });   
   }

   onCloseModal = () => {
      if (this.props.accountType === 'ENTERPRISE_FREE' && this.state.page !== 3) {
         this.props.history.push("/employers");
      } else if (this.props.accountType === 'ENTERPRISE_FREE' && this.state.page === 3) {
         window.location.href = "/t/employer/job/";
      }
      if (this.props.accountType === 'ENTERPRISE_CUSTOM') {
         this.props.history.push("/enterprise");
      }
   };


   render() {

      const { accountType } = this.props;
      const { page, isIPAddressBlacklisted, isValidInternational } = this.state;

      return (
         <Modal isOpen={true} className="rounded_modal" toggle={this.onCloseModal} backdrop="static" keyboard={true}>
            <button type="button" onClick={this.onCloseModal} className="close modalClose" aria-label="Close"><span
               aria-hidden="true">&times;</span></button>
            {
               page === 1
               &&
               <EmployerRegistrationForm
                  onEmployerRegistrationFormSuccess={this.onEmployerRegistrationFormSuccess}
                  accountType={accountType}
                  isIPAddressBlacklisted={isIPAddressBlacklisted}
                  isValidInternational={isValidInternational}
                  initialValues={{ isTermsAccepted: true }}
                  email={this.setEmail}
                  password={this.setPW}
               />
            }
            {
               page === 2
               &&
               <EmployerDetailsForm
                  onEmployerRegistrationFormSuccess={this.onEmployerRegistrationFormSuccess}
                  accountType={accountType}
                  setCompany={this.setCompany}
                  initialValues={{
                     phone: "",
                     numberOfJobs: { value: '1 to 9 jobs', label: '1 to 9 jobs' }
                  }}
               />
            }
            {
               this.props.accountType === 'ENTERPRISE_FREE'
               && page === 3
               &&
               <EmployerJobDetails
                  onEmployerRegistrationFormSuccess={this.onEmployerRegistrationFormSuccess}
                  email={this.state.email}
                  password={this.state.password}
                  initialValues={{
                     organization: this.state.currentCompany,
                     infoEmploymentType: { value: 'fulltime', label: 'Full-Time' },
                     infoCompensationType: { value: 'annually', label: 'Annually' },
                     validThroughPicker: { value: 'filled', label: 'Until Filled' },
                     infoCompensation: "", // making input controlled
                     infoCompensationMin: "", // making input controlled
                     infoCompensationMax: "", // making input controlled
                  }}
               />
            }
            {
               accountType === 'ENTERPRISE_CUSTOM'
               && page === 3
               && <EmployerEnterpriseCustomSuccess />
            }
         </Modal>
      )
   }
}

export default withRouter(EmployerRegistration);
